<div class="flex flex-col items-center justify-center">
    <div class="w-full flex items-center justify-end">
        <button class="w-6 h-6 rounded-md bg-gray-100" (click)="onDismiss()">
            <i class="fas fa-times text-sm text-gray-500"></i>
        </button>
    </div>
    <p class="mt-2 text-lg text-gray-700 font-semibold">{{title}}</p>
    <p class="text-gray-600 mt-4 leading-6 text-center text-lg">{{message}}</p>
    <div mat-dialog-actions class="mt-8 flex justify-end items-center">
        <button (click)="onDismiss()" class="font-display text-blue-900 border border-blue-900 text-xs font-medium px-4 py-3 rounded-md">Tidak</button>
        <button (click)="onConfirm()" class="ml-2 font-display text-white border border-blue-900 bg-blue-900 font-medium text-xs px-4 py-3 rounded-md">Ya</button>
    </div>
</div>